export interface ModelOption {
  modelCode: string;
  name: string;
}

/**
 * Builds the Model dropdown options for the edit-device form, ensuring the
 * device's current model is always selectable — even when it isn't a catalog
 * entry. Fleet-provisioned units report free-form model strings (e.g.
 * `safe-t-hdv-two-way-comms`) that were never added to the device-model
 * catalog; without this the <select> can't render the current value, silently
 * falls back to "No model", and saving would wipe the model.
 */
export function modelOptionsWithCurrent(
  currentModel: string,
  catalog: Array<{ modelCode: string; name: string }>,
): ModelOption[] {
  const base = catalog.map((m) => ({ modelCode: m.modelCode, name: m.name }));
  if (currentModel && !base.some((m) => m.modelCode === currentModel)) {
    return [{ modelCode: currentModel, name: `${currentModel} (current)` }, ...base];
  }
  return base;
}
